import { render, staticRenderFns } from "./NavDesktop.vue?vue&type=template&id=83883cf8&scoped=true&"
import script from "./NavDesktop.vue?vue&type=script&lang=js&"
export * from "./NavDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83883cf8",
  null
  
)

export default component.exports